import { getConfig } from '@superbet-group/web.lib.config';
import { createRestClient } from '@superbet-group/web.lib.rest';

import { defaultHttpTimeoutMs } from '@core/constants';
import { getCmsUrl } from '@core/services/cms/utils';

export function createCategoryIconsService() {
    const restClient = createRestClient(getConfig().cms?.baseUrl ?? '', defaultHttpTimeoutMs);

    function getCategoryIconMappings(): Promise<CategoryIconMapping[]> {
        return restClient.get<CategoryIconMapping[]>(
            getCmsUrl({
                path: '/category-icon-mappings',
            }),
        );
    }

    return {
        getCategoryIconMappings,
    };
}

export type CategoryIconMapping = {
    iconKey: string;
    categoryIds: number[];
};
